import { lazy } from 'react';
import { QueryClient } from '@tanstack/react-query';
import {
	experimental_createQueryPersister,
	type AsyncStorage,
} from '@tanstack/react-query-persist-client';
import { get, set, del, entries, createStore, type UseStore } from 'idb-keyval';

export const ReactQueryDevtoolsProduction = lazy(() =>
	import('@tanstack/react-query-devtools/build/modern/production.js').then(
		(d) => ({
			default: d.ReactQueryDevtools,
		}),
	),
);
const store = createStore('canvasflow_db', 'react-query-cache')
const storage = idbStorage(store);

export async function clearPersistStorage() {
	if (!storage.entries) {
		return;
	}

	for (const [key] of await storage.entries()) {
		await storage.removeItem(key)
	}

}

export const persister = experimental_createQueryPersister({
	storage,
	prefix: 'cf-query',
	maxAge: 1000 * 60 * 60 * 12, // 12 hours,
	// Just pass the data
	serialize: (persistedQuery: any) => persistedQuery,
	deserialize: (cache: any) => cache,
});

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			gcTime: 1000 * 2,
			staleTime: 1000 * 10,
			persister: persister.persisterFn,
		},
	},
});

function idbStorage(idbStore: UseStore): AsyncStorage {
	return {
		getItem: async (key) => get(key, idbStore),
		setItem: async (key, value) => set(key, value, idbStore),
		removeItem: async (key) => del(key, idbStore),
		entries: async () => entries(idbStore)
	};
}
